import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Terren
 * id 09E0675C-053B-4548-9FC1-2F8DC3B49364
 * name file-word-box-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-word-box-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileWordBoxOutlineIcon = createSvgIcon(<><path d="M5 3C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3H5M5 5H19V19H5V5M17.9 7L15.5 17H14L12 9.5L10 17H8.5L6.1 7H7.8L9.34 14.5L11.3 7H12.7L14.67 14.5L16.2 7H17.9Z" /></>, 'FileWordBoxOutlineIcon');
export default FileWordBoxOutlineIcon